/**
 * Configuration constants for the Mini App
 */

// Debug Mode (Feature Flag)
export const DEBUG_MODE = process.env.REACT_APP_DEBUG_MODE === 'true' || false;

// Smart API Router (Feature Flag)
// Enables automatic failover between primary and replica endpoints
// Can be enabled via: 1) ENV variable, 2) URL parameter (?smart=1)
export const ENABLE_SMART_ROUTER = 
  process.env.REACT_APP_ENABLE_SMART_ROUTER === 'true' ||
  new URLSearchParams(window.location.search).get('smart') === '1';

// Debug helpers (no-op if DEBUG_MODE is false)
export const debugLog = (...args) => {
  if (DEBUG_MODE) {
    console.log('[DEBUG]', ...args);
  }
};

export const debugWarn = (...args) => {
  if (DEBUG_MODE) {
    console.warn('[WARN]', ...args);
  }
};

// Note: console.error() оставляем без условия для критических ошибок

// API Base URL - for Cloudflare Pages we need absolute URL
// Remove trailing slash to prevent double slashes
// Supports both REACT_APP_API_URL (dev) and REACT_APP_API_PRIMARY (prod)
// Fallback to production URL if env vars are not set (safety net for Cloudflare Pages)
export const API_BASE_URL = (
  process.env.REACT_APP_API_URL || 
  process.env.REACT_APP_API_PRIMARY || 
  'https://vpn-admin.shurik.ch'
).replace(/\/$/, '');

// API Replica URL - VDS Mirror (для автоматического failover)
export const API_REPLICA_URL = (process.env.REACT_APP_API_REPLICA || '').replace(/\/$/, '');

// App version (Semantic Versioning)
export const APP_VERSION = process.env.REACT_APP_VERSION || '2.3.0';

// Build number (GitHub Actions run_number)
export const BUILD_NUMBER = process.env.REACT_APP_BUILD_NUMBER || '';

// Full version with build number (if available)
export const FULL_VERSION = BUILD_NUMBER 
  ? `${APP_VERSION}-b${BUILD_NUMBER}`
  : APP_VERSION;

// Helper: Fetch with fallback
export const fetchWithFallback = async (path, options = {}) => {
  const urls = [
    API_BASE_URL ? `${API_BASE_URL}${path}` : path,
    API_REPLICA_URL ? `${API_REPLICA_URL}${path}` : null
  ].filter(Boolean);

  let lastError = null;

  for (const url of urls) {
    try {
      const response = await fetch(url, {
        ...options,
        signal: AbortSignal.timeout(10000) // 10 second timeout
      });
      
      if (response.ok) {
        return response;
      }
      
      lastError = new Error(`HTTP ${response.status}: ${response.statusText}`);
    } catch (error) {
      console.warn(`Failed to fetch from ${url}:`, error.message);
      lastError = error;
    }
  }

  throw lastError || new Error('All API endpoints failed');
};

